import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * Cart drawer component
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent =
        document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta =
        installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

/* ✅ BDF — Add-ons Add Button Handler */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.bdf-cart-addon-add');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    });

    // refresh so drawer updates
    window.location.reload();
  } catch (err) {
    console.error('Add-on add failed', err);
    btn.disabled = false;
    alert('Could not add item. Please try again.');
  }
});
